import { FC } from 'react'

import { AIAssistant, AppIconSizes, AppIconVariants } from '@inno-ui/app-icons'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import styles from './ArtifactUnavailable.module.scss'

interface ArtifactUnavailableProps {
  onRetry?: () => void
  compact?: boolean
}

export const ArtifactUnavailable: FC<ArtifactUnavailableProps> = ({
  onRetry,
  compact
}) => {
  const { t } = useTranslation('translation', { keyPrefix: 'widgets.aiAgent' })

  return (
    <div className={cn(styles.wrap, { [styles.compact]: compact })}>
      <span className={styles.badge} aria-hidden='true'>
        <AIAssistant
          variant={AppIconVariants.Colored}
          size={AppIconSizes.Size48}
        />
      </span>
      <div className={styles.title}>{t('offlineTitle')}</div>
      <div className={styles.text}>{t('offlineText')}</div>
      {onRetry && (
        <button type='button' className={styles.retry} onClick={onRetry}>
          {t('tryAgain')}
        </button>
      )}
    </div>
  )
}
